// extracted by mini-css-extract-plugin
module.exports = {"outerClassName":"Invites_outerClassName__1FUGJ"};